import { variables } from '../../../cssInJs';

export default{
  span__link : {
    color: variables.redColor,
    cursor: 'pointer'
  }
}